export function determineTooltipSide(
  domElement: HTMLCanvasElement,
  tooltipWidth: number,
  tooltipHeight: number,
  anchorX: number,
  anchorY: number,
  pixelRatio: number,
) {
  const windowWidth = domElement.width / pixelRatio;
  const windowHeight = domElement.height / pixelRatio;

  const spaceTop = anchorY;
  const spaceBottom = windowHeight - anchorY;
  const spaceLeft = anchorX;
  const spaceRight = windowWidth - anchorX;

  const canFitTop =
    tooltipHeight <= spaceTop && tooltipWidth / 2 <= spaceLeft && tooltipWidth / 2 <= spaceRight;
  const canFitBottom =
    tooltipHeight <= spaceBottom && tooltipWidth / 2 <= spaceLeft && tooltipWidth / 2 <= spaceRight;
  const canFitLeft =
    tooltipWidth <= spaceLeft && tooltipHeight / 2 < spaceTop && tooltipHeight / 2 < spaceBottom;
  const canFitRight =
    tooltipWidth <= spaceRight && tooltipHeight / 2 < spaceTop && tooltipHeight / 2 < spaceBottom;

  const sides = [
    { side: 'top', space: spaceTop, canFit: canFitTop, priority: 3 },
    { side: 'bottom', space: spaceBottom, canFit: canFitBottom, priority: 4 },
    { side: 'left', space: spaceLeft, canFit: canFitLeft, priority: 2 },
    { side: 'right', space: spaceRight, canFit: canFitRight, priority: 1 },
  ];

  const fitSides = sides.filter((side) => side.canFit);

  if (fitSides.length === 0) {
    return 'no space';
  }

  fitSides.sort((a, b) => {
    if (a.priority !== b.priority) {
      return a.priority - b.priority;
    }
    return b.space - a.space;
  });

  return fitSides[0].side;
}
